import { useNavigation } from '@/app/hooks'
import { isNativeMobile } from '@/authenticated/hooks/useIsMobile'
import { setPendingOnComplete } from './onCompleteRegistry'

export function useInitConfigureDeviceFlow() {
  const navigate = useNavigation()

  const initFlow = ({
    deviceIds,
    setupMobile,
    onComplete,
  }: {
    deviceIds: (number | string)[]
    setupMobile: boolean
    onComplete?: () => void
  }) => {
    const ids = [...deviceIds]
    // Skip the mobile-app-download step when the user is already inside the
    // native React Native WebView — they don't need to download the app.
    if (setupMobile && !isNativeMobile()) {
      ids.push('mobile')
    }
    setPendingOnComplete(onComplete)
    const searchParams = new URLSearchParams([['deviceIds', ids.join()]])
    navigate.push(`/configure-devices/init?${searchParams.toString()}`)
  }

  return { initFlow }
}
